import React, { useEffect, useState } from 'react';
import '../styles/Preferences.css';
import { Header, Footer, Button } from '../components';
import { checkOnAuthStateChanged, setData } from '../functions';
import { useNavigate } from 'react-router-dom';

function Preferences() {
    const [loggedIn, setLoggedIn] = useState(null);
    const [userId, setUserId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Preferences | Clozers";

        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                setUserId(user.userId);
                setLoggedIn(true);
            }
            else {
                setLoggedIn(false);
                navigate("/");
            }
        }
        fetchUserData();

    }, [navigate]);

    const saveChanges = async() => {
        const colRef = "settings";
        const newObject = {
            bestCompsCount: 3,
            listingTypes: {
                forSale: true,
                pending: true,
                sold: true
            }
        };

        await setData(colRef, userId, newObject);
    };

    return (
        <div className="preferences-outer-container">
            <Header
                loggedIn={loggedIn}
            />
            <div className="preferences-inner-container">
                <div className="preferences-title-container">
                    <h1 className="heading-large-bold colour-primary text-align-center">
                        Preferences
                    </h1>
                    <span className="body-regular colour-secondary block-text text-align-center">
                        Update your preferences here.
                    </span>
                    <Button
                        buttonType="primary-button"
                        size="large"
                        text={"Save Changes"}
                        cta={() => saveChanges()}
                        disabled={false}
                        leftIcon={false}
                        leftIconClass=""
                        rightIcon={null}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default Preferences;